export default __webpack_public_path__ + "static/media/detail.638128cf.png";